import { render } from "./Works.vue?vue&type=template&id=2e1599fd&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=2e1599fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1599fd"]])

export default __exports__